
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m17.72 5.12727h3.6c.3976 0 .72.34189.72.76363v12.2182c0 .4217-.3224.7636-.72.7636h-3.6c-.3977 0-.72.3419-.72.7637 0 .4217.3223.7636.72.7636h3.6c1.1929 0 2.16-1.0257 2.16-2.2909v-12.2182c0-1.26523-.9671-2.29091-2.16-2.29091h-3.6c-.3977 0-.72.34189-.72.76364 0 .42174.3223.76364.72.76364zm-5.3092 9.38753c-.2812.2982-.2812.7817 0 1.0799.2812.2983.7371.2983 1.0182 0l2.88-3.0545c.2812-.2982.2812-.7817 0-1.0799l-2.88-3.05459c-.2811-.29822-.737-.29822-1.0182 0s-.2812.78173 0 1.07995l1.6512 1.75124h-8.34195c-.39765 0-.72.3419-.72.7637 0 .4217.32235.7636.72.7636h8.34135z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    